import { Driver } from 'src/interfaces/driver'
import { State } from '../reducers/types'

export const getDriver = (state: State): Driver | null => state.driver.driver
